import { LineData, UTCTimestamp } from 'lightweight-charts';
import { TradingMovement } from './chartsConfig';

/* eslint-disable unicorn/prefer-code-point*/
export const getStringHash = (str: string) => Math.abs([...str].reduce((s, c) => Math.trunc(Math.imul(31, s) + c.charCodeAt(0)), 0));

export const convertChartToLineData = (data: string[]) =>
  data
    .map((d) => d.split('|'))
    .map((split) => ({
      time: (new Date(`${split[0]}Z`).getTime() / 1000) as UTCTimestamp,
      value: Number.parseFloat(split[1])
    }));

export const getTradingColour = (data: LineData[]) => {
  const first = data[0].value;
  const last = data[data.length - 1].value;
  if (first === last) {
    return TradingMovement.EQUAL;
  }
  return first < last ? TradingMovement.UP : TradingMovement.DOWN;
};
